// Token validity
export function isJwtValid(): boolean {
  return getJwtExpiration() >= new Date();
}

// Token expiration
export function getJwtExpiration(): Date {
  return new Date(window.sessionStorage.getItem('expiration') as string);
}
